<template>
  <v-dialog max-width="500px" v-model="inDialog" @click:outside="onClickOutside" persistent>
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formCreateName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>


        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Số thứ tự topic')"
                  v-model.trim="item.unitOrder"
                  name="unitOrder"
                  v-validate="'required'"
                  maxLength="250"
                  :error-messages="errors.first('unitOrder')"
                  :data-vv-as="$t('Tên topic')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="levels"
                  :label="$t('Level')"
                  v-model="item.levelId"
                  name="levelId"
                  item-value="levelId"
                  item-text="levelName"
                  v-validate="'required'"
                  :data-vv-as="$t('Level')"
                  :error-messages="errors.first('levelId')"
                  :disabled="item.pondId ? true : false"
                  v-on:change="levelChange(item.levelId)"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Tên topic')"
                  v-model.trim="item.unitName"
                  name="className"
                  v-validate="'required'"
                  maxLength="250"
                  :error-messages="errors.first('unitName')"
                  :data-vv-as="$t('Tên topic')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                  type="text"
                  :label="$t('Nội dung topic')"
                  v-model.trim="item.unitContent"
                  name="unitContent"
                  maxLength="250"
                  :error-messages="errors.first('unitContent')"
                  :data-vv-as="$t('Nội dung topic')"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
      <div style="text-align: right">
        <v-btn color="primary" @click="onSave">
          <v-icon dark left>save</v-icon>
          {{ $t("lang.common.save") }}
        </v-btn>
        <v-btn color="error" @click="onCancel">
          <v-icon dark left>cancel</v-icon>
          {{ $t("lang.common.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {message} from "../../../services";
import axios from "axios";
import {areaContants} from "@/constants";
import moment from "moment/moment";

export default {
  name: "material-type-group-create",
  components: {message, axios},
  props: {
    propsItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    levels: {
      type: Array,
      default: [],
    },
    cDialog: {
      type: Boolean,
      default: false,
    },
    formCreateName: {
      type: String,
      default: '',
    },
    units: {
      type: Array,
      default: [],
    },

    programs: {
      type: Array,
      default: [],
    },
  },
  data: () => {
    return {
      areaStatus: areaContants.areaStatus,
      item: {
        unitName: "",
        unitContent: "",
        levelId:"",
        unitOrder:"",
      },
      inDialog: false,
    };
  },
  watch: {
    propsItem: {
      handler(value) {
        //console.log(value);
        if (value !== null) {
          this.item = {
            unitId: value.unitId,
            unitOrder: value.unitOrder
                ? value.unitOrder
                : "",
            unitName: value.unitName
                ? value.unitName
                : "",
            unitContent: value.unitContent
                ? value.unitContent
                : "",
            levelId: value.levelId
                ? value.levelId
                : "",
            status: value.status ? value.status : 0,
            isActive: value.isActive ? value.isActive : 0,
          };
        } else {
          this.resetFrom();
        }
      },
      deep: true,
    },
    cDialog(value) {
      this.inDialog = value;
    },
    inDialog(value) {
      if (!value) {
        this.$emit("closeCreateDialog", "");
      }
    },
  },
  methods: {
    resetFrom: function () {
      this.item = {
        missionName: "",
        missionContent: "",
        programID: "",
        levelId:"",
        unitOrder:"",
      };
    },
    checkMinDate(minDate = moment()) {
      if (minDate == '' || minDate == null) minDate = moment();
      let minDate_tmp = moment(String(minDate));
      let today = moment();
      // if (minDate_tmp <= today) {
      //     minDate = moment().format('YYYY-MM-DD');
      // } else {
      minDate = minDate_tmp.format('YYYY-MM-DD');
      // }
      return minDate;
    },
    clearDropDate() {
      this.item.startDate = '';
    },
    levelChange(levelId) {
      this.getNextCode();
    },
    getNextCode: function () {
      axios.post(
          process.env.VUE_APP_API_URL + "/babiLevel/listAllName", {status: 1}
      )
          .then((data) => {
            this.item = Object.assign({}, this.item, {"code": data})
          });
    },
    onCancel: function () {
      this.$emit("closeCreateDialog", "");
    },
    onSave: function () {
      // console.log(this.item);
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/babiUnit/save",
                this.item
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.resetFrom();
                    this.onCancel();
                  } else {
                    let msg = data.description;
                    if (data.description === 'lang.category.duplicateCode') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    } else if (data.description === 'lang.category.duplicateName') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    }
                    message.error(this.$t(msg));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },

  },
  created() {
    axios.post(
        process.env.VUE_APP_API_URL + "/babiLevel/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.levels = data;
              }
            }
        );
  },
};
</script>
